import { createFileRoute } from '@tanstack/react-router';
import { GeneralSettingsScreen } from '../../../features/B9/general-settings';

// Settings → "כללי" — lane B9. Page head + tabs come from the settings layout (_app/settings.tsx, lane B1).
export const Route = createFileRoute('/_app/settings/general')({
  component: GeneralSettingsScreen,
});
